import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import { protectedRoutes, publicRoutes } from 'configs/RoutesConfig';
import ProtectedRoute from './ProtectedRoute';
import PublicRoute from './PublicRoute';
import AppRoute from './AppRoute';
import MyContext from '../context';
import { useTranslation } from 'react-i18next';
import ModuleList from 'views/dashboard/module_list';

const Routes = () => {
    const { t } = useTranslation(['common', 'home'])
    let contextValue = { t };

    return (
        <MyContext.Provider value={contextValue}>
            <RouterRoutes>
                <Route path="/" element={<ProtectedRoute />}>
                    <Route path="/" element={<Navigate replace to={AUTHENTICATED_ENTRY} />} />
                    <Route path="/dashboard/module-list" element={<ModuleList />} />
                    {protectedRoutes.map((route, index) => {
                        return (
                            <Route
                                key={route.key}
                                path={`${route.path}/*`}
                                element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />}
                            />
                        );
                    })}
                </Route>
                <Route path="/" element={<PublicRoute />}>
                    {publicRoutes.map((route) => {
                        return (
                            <Route
                                key={route.key}
                                path={route.path}
                                element={<AppRoute routeKey={route.key} component={route.component} {...route.meta} />}
                            />
                        );
                    })}
                </Route>
            </RouterRoutes>
        </MyContext.Provider>
    );
};

export default React.memo(Routes);
